import React from "react";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import BugReportIcon from "@material-ui/icons/BugReport";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  button: {
    color: "#ffffff",
  },
}));

const BugReportButton = ({ onClick }) => {
  const classes = useStyles();

  return (
    <Tooltip title="דווח על תקלה">
      <IconButton className={classes.button} onClick={onClick}>
        <BugReportIcon />
      </IconButton>
    </Tooltip>
  );
};

export default BugReportButton;
